import api from './api';

/**
 * Calculate bulk shipping fees for multiple items (admin version)
 * @param {Array<Object>} items - Array of items with shipping info
 * @param {Object} items[].num_iid - Item ID
 * @param {Object} items[].sku_data - SKU data object (keyed by SKU pk ID)
 * @param {string} items[].area_id - Destination area ID
 * @param {string} items[].site - Site identifier (default: '1688')
 * @returns {Promise<Object>} API response with shipping fees
 */
export const calculateBulkShippingFees = async (items) => {
  try {
    const response = await api.post('/admin/core/shipping/calculate-bulk-fees/', {
      items
    }, {
      timeout: 60000 // 60 seconds for OneBound API calls
    });
    
    return response.data;
  } catch (error) {
    console.error('Error calculating bulk shipping fees:', error);
    throw error;
  }
};

const shippingService = {
  calculateBulkShippingFees
};

export default shippingService;
